import {
    Component,
    Inject,
    OnInit, Optional,
} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {Peticiones} from "../services/Peticiones";

// estados-producto.enum.ts
export enum EstadoProducto {
    Pendiente = 1,
    EnTransito,
    Entregado
}

@Component({
    selector: 'ral-peticiones_detalle_devolucion',
    templateUrl: './detalle_devolucion.component.html',
    styleUrls: ['./detalle_devolucion.component.scss']
})
export class DetalleDevolucionComponent implements OnInit
{
    peticion = ""

    estadoActual: EstadoProducto = EstadoProducto.Pendiente;

    cargaDatos1 = true;

    estadoTexto: string = "En transito";

    constructor(private http: HttpClient,
                private route: ActivatedRoute,
                public dialog:MatDialog,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

            console.log(data);
            if (this.peticion == "" && data != null) {
                this.peticion = data.peticion;
                Peticiones.getDetalleDevolucionPet(this.http, this.peticion).then((res) => {
                    if (res >= 4){
                        this.avanzarEstado();
                        this.estadoTexto = "Devolucion finalizada";
                    }
                    if (res >= 2){
                        this.avanzarEstado();
                        this.estadoTexto = "Procesando";
                    }
                    this.cargaDatos1 = false;
                });
            }

            if (this.peticion) {
                console.error("Petición not provided. This component requires either a route parameter or dialog data.");

            }
    }

    // Cambiar estado manualmente para probar
    avanzarEstado(): void {
        if (this.estadoActual < EstadoProducto.Entregado) {
            this.estadoActual++;
        }
    }

    ngOnInit(): void {
    }
}
